<template>
  <v-card>
    <div class="google-map" :id="mapName" :key="loaded"></div>
  </v-card>
</template>

<script>
/* global google */
export default {
  name: 'google-map',
  props: {
    parentID: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      mapName: 'Device Map',
      markerCoordinates: [{
        latitude: 50.969656,
        longitude: -1.351566,
        devicename: 'B4T',
        displayname: 'Thing Mongers',
        colour: 'green',
        icon: 'green-dot.png'
      }],
      map: null,
      bounds: null,
      markers: [],
      devices: [],
      loaded: 0
    }
  },
  methods: {
    buildDeviceList (data) {
      // ..and set to the v-table bound :items
      this.devices = data.devices
      data.devices.forEach((device) => {
        this.putMarker(
          device.identity_data.displayname,
          device.devicename,
          device.identity_data.loc_lat,
          device.identity_data.loc_lon)
      })
    },
    fetchDevices () {
      var urlParams = {}
      if (this.parentID && this.parentID >= 0) {
        urlParams.parentid = this.parentID
      }
      // Get the list of devices
      this.$http
        .get('/schemas/devices', { params: urlParams })
        .then(request => this.buildDeviceList(request.data))
        .catch(() => this.failedDeviceList())
    },
    failedDeviceList () {
      this.$emit('error', 'Failed to retrieve a list of devices.')
    },
    putMarker (displayname, devicename, latitude, longitude) {
      if (latitude !== 0 && longitude !== 0) {
        this.markerCoordinates.push({
          latitude: latitude,
          longitude: longitude,
          displayname: displayname,
          devicename: devicename,
          colour: 'red',
          icon: 'red-dot.png'
        })
        this.loaded += 1
      }
    },
    addInfoWindow (map, marker, content) {
      var infoWindow = new google.maps.InfoWindow({
        size: new google.maps.Size(50, 50)
      })
      infoWindow.setContent(content)
      infoWindow.open(map, marker)
      this.addListener(map, marker, infoWindow)
    },
    addListener (map, marker, infowindow) {
      // This event expects a click on a marker
      // When this event is fired the Info Window is opened.
      google.maps.event.addListener(marker, 'click', function () {
        infowindow.open(map, marker)
      })

      // Event that closes the Info Window with a click on the map
      google.maps.event.addListener(map, 'click', function () {
        infowindow.close()
      })
    },
    createMap () {
      this.bounds = new google.maps.LatLngBounds()
      const element = document.getElementById(this.mapName)
      const mapCentre = this.markerCoordinates[0]
      const options = {
        center: new google.maps.LatLng(mapCentre.latitude, mapCentre.longitude)
      }
      this.map = new google.maps.Map(element, options)
      this.markerCoordinates.forEach((coord) => {
        const position = new google.maps.LatLng(coord.latitude, coord.longitude)
        const marker = new google.maps.Marker({
          position,
          map: this.map,
          icon: 'https://www.google.com/intl/en_us/mapfiles/ms/micons/' + coord.icon,
          label: {
            text: coord.devicename,
            color: coord.colour,
            fontWeight: 'bold'
          }
        })
        var content = `<b>(${coord.devicename}) ${coord.displayname}<p>${coord.latitude}, ${coord.longitude}</p></b>`
        this.addInfoWindow(this.map, marker, content)
        this.markers.push(marker)
        this.map.fitBounds(this.bounds.extend(position))
      })
    }
  },
  beforeMount () {
    this.fetchDevices()
  },
  mounted () {
    setTimeout(this.createMap, 250)
    // this.createMap()
  }
}
</script>

<style scoped>
.google-map {
  height: 400px;
  margin: 0 auto;
  background: gray;
}
</style>
